import React from 'react';
import { useTranslation } from 'react-i18next';
import { IkeOrIkzeLimits } from './IkeOrIkze';

interface IkzeTaxBenefitsProps {
  limits?: IkeOrIkzeLimits;
}

const IkzeTaxBenefits: React.FC<IkzeTaxBenefitsProps> = ({ limits }) => {
  const { t } = useTranslation('ike-or-ikze');
  const pitYear = limits?.year ? limits.year : new Date().getFullYear();

  return (
    <ul>
      <li>
        {t('ikze.tax_benefits')}
      </li>
      <li>
        {t('ikze.tax_benefits_second', '',
          { pitYear, taxLimit: limits?.ikzeTaxLimit, entrepreneurTaxLimit: limits?.ikzeEntrepreneurTaxLimit })
        }
      </li>
    </ul>
  );
};

export default IkzeTaxBenefits;
